/**
 * Decodes a JWT token and returns its payload.
 * @param token - The JWT token string to decode.
 * @returns The decoded payload as a CognitoTokenPayload object.
 */
interface CognitoTokenPayload {
    "cognito:username": string;
    exp: number;
    [key: string]: any; // Allow for other JWT claims
}

export function UseDecodeToken(token: string): CognitoTokenPayload {
    if (!token) {
        return {} as CognitoTokenPayload;
    }
    const arrayToken = token.split(".");
    const tokenPayload = JSON.parse(atob(arrayToken[1]));
    return tokenPayload as CognitoTokenPayload;
}
